// Be careful importing an entire directory.
// Some files setup namespaced objects, other files immediately execute (on ready) and will be included in the objects on the global object.
function importFiles(filesRequire) {
    filesRequire.keys().forEach(filesRequire)
}

// Require bootstrap and related libs
require('./bootstrap');

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Require ABCSetup global namespace and global libs
//
///////////////////////////////////////////////////////////////////////////////////////////////////
require('./abcsetup');
require('./alert_boxes');

// Load moment.js
//window.moment = require('moment');
window.moment = require('moment-timezone');
window.momentBusinessDays = require('moment-business-days');

// Globals
importFiles(require.context('./lib/', true, /\.js$/i));

// Datatables
require('datatables.net-plugins/pagination/input');
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-responsive-bs4');
require('datatables.net-fixedcolumns-bs4');
//require('datatables.net-colreorder-bs4');
//require('datatables.net-fixedheader-bs4');
//require('datatables.net-scroller-bs4')();
//require('datatables.net-searchbuilder-bs4')();
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.print.js');
window.Editor = require('./datatable-editor/dataTables.editor.js');
require('./datatable-editor/editor.bootstrap4.js');

// Add timestamps to the console logs
// TODO: One issue with this is it breaks logging things other than strings e.g. console.log({a: 1})
require('log-timestamp')(
    function () {
        // Create a date object with the current time
        // return a formatted timestamp
        var now = new Date();
        var date = [now.getFullYear(), now.getMonth() + 1, now.getDate()];
        var time = [now.getHours(), now.getMinutes(), now.getSeconds()];
        for (var i = 0; i < 3; i++) {
            if (time[i] < 10) {
                time[i] = "0" + time[i];
            }
        }
        for (var i = 1; i < 3; i++) {
            if (date[i] < 10) {
                date[i] = "0" + date[i];
            }
        }
        return date.join("-") + " " + time.join(":") + ": %s";
    }
);

window.JSZip = require('jszip');
//require('pdfmake');
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Load jquery-slimscroll
window.slimscroll = require('jquery-slimscroll');

// Load QRCode
window.QRCode = require('qrcode');

// Load jQuery Mask
window.jQueryMask = require('jquery-mask-plugin');

// ekko-lightbox
window.lightbox = require('ekko-lightbox');

// Toastr
window.toastr = require('toastr');

// Livewire sortable
require('livewire-sortable');

/*
// Pusher
require('pusher-js')

// Laravel Echo
import Echo from 'laravel-echo';

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'd99d73bb176551619a79',
    cluster: 'us2',
    forceTLS: true,
    encrypted: true,
});
*/

// Local storage
window.ls = require('local-storage');

// jQuery Form
require('jquery-form');

// bootstrap-autocomplete
require('bootstrap-autocomplete');

// jquery.cookie
require('jquery.cookie');

// html2canvas
window.html2canvas = require('html2canvas');

// select2
require('select2');

// signature pad
window.SignaturePad = require('signature_pad');

// ckeditor
require('./ckeditor/_include');

// sync-scroll
require('sync-scroll');

// sortablejs
window.Sortable = require('sortablejs').Sortable;

// cytoscape and cytoscape-dagre
import cytoscape from "cytoscape";
import dagre from "cytoscape-dagre";
import cyPanzoom from "cytoscape-panzoom";

window.cytoscape = cytoscape;
window.dagre = dagre;
window.cyPanzoom = cyPanzoom;

require('bootstrap4-toggle');
require('jquery-ui-sortable');

// This was causing a global display issue - we should only use formBuilder when required
//require('formBuilder');
//require('formBuilder/dist/form-render.min');

window.XLSX = require('xlsx');

// file-saver
import saveAs from 'file-saver';
window.saveAs = saveAs;

// daterangepicker
require('daterangepicker');

// bootstrap-suggest
require('bootstrap-suggest');

// jquery-ui
require("jquery-ui/ui/widgets/accordion");
require("jquery-ui/ui/widgets/sortable");

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Require ABCSetup specific js namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
require('./alerts');
require('./app_switcher');
require('./attachments');
require('./calendars');
require('./datatables/all');
require('./idletimeout');
require('./import_handler');
require('./notifications');
//require('./pusher');
require('./recaptcha');
require('./zendesk');

importFiles(require.context('./modals/', true, /\.js$/i));

// Form related namespaces
importFiles(require.context('./forms/', true, /\.js$/i));

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Require ABCSetup routes
//
///////////////////////////////////////////////////////////////////////////////////////////////////
// Auth namespaces
importFiles(require.context('./routes/auth/', true, /\.js$/i));

// Dashboard namespaces
require('./routes/_dashboard');
importFiles(require.context('./routes/dashboards/', true, /\.js$/i));

// Consumer RFP
importFiles(require.context('./routes/consumer_rfp/', true, /\.js$/i));

// Front Store namespaces
require('./routes/front_store/_create');
require('./routes/front_store/_edit');
require('./routes/front_store/_show');
require('./routes/front_store/_workflow');
require('./routes/image_collection/item_image_request/_index');
// require('./routes/front_store/_maintenance');

// Front Store Maintenance namespaces
require('./routes/front_store/maintenance/_edit');
require('./routes/front_store/maintenance/_show');
require('./routes/front_store/maintenance/_workflow');

// RxItem namespaces
require('./routes/rx_item/_create');
require('./routes/rx_item/_edit');
require('./routes/rx_item/_show');
require('./routes/rx_item/_workflow');
// require('./routes/rx_item/_maintenance');

// RxMaintenance namespaces
require('./routes/rx_item/maintenance/_edit');
require('./routes/rx_item/maintenance/_show');
require('./routes/rx_item/maintenance/_workflow');

// Price Change namespaces
require('./routes/price_change/_workflow');
require('./routes/price_change/_suppliers');

// Existing Items
require('./routes/abc_item/_index');
require('./routes/abc_item/_request_pr_docs');

// Audit Logs
require('./routes/audit_logs/_index');
require('./routes/audit_logs/_details');

// Rx Item HDA Forms
require('./routes/rx_item_hda_form/_index');

// NonRx Item HDA Forms
require('./routes/nonrx_item_hda_form/_index');

// Consumer Import Items
require('./routes/front_store_import_items/_index');
require('./routes/front_store_import_items/_load_data');

// Rx Import Items
require('./routes/rx_import_items/_index');
require('./routes/rx_import_items/_load_data');

// Item Maintenance
require('./routes/item_maintenance/_reports');

// Workflow Tasks
require('./routes/workflow_tasks/_index');
importFiles(require.context('./routes/workflows/', true, /\.js$/i));

// Promos
importFiles(require.context('./routes/promos/', true, /\.js$/i));
importFiles(require.context('./routes/promos/plans/', true, /\.js$/i));
importFiles(require.context('./routes/promos/gnp/', true, /\.js$/i));

// PR Docs
require('./routes/pr_docs/_index');

// Roles
importFiles(require.context('./routes/roles/', true, /\.js$/i));

// RFQ
require('./routes/rfq/_comments');
require('./routes/rfq/_common');
require('./routes/rfq/_create');
require('./routes/rfq/_edit');
require('./routes/rfq/_summary');
require('./routes/rfq_transfers/_index');
importFiles(require.context('./routes/rfq/bid_requests/', true, /\.js$/i));
importFiles(require.context('./routes/rfq/supply_issues/', true, /\.js$/i));

// Template
require('./routes/template/_edit');

// Report Type
require('./routes/report_type/_index');
require('./routes/report_type/_run');
require('./routes/report_type/_edit');

// ThoughtSpot
importFiles(require.context('./routes/thoughtspot/', true, /\.js$/i));

// Users
importFiles(require.context('./routes/users/', true, /\.js$/i));

// Item Setup Complete Notify
require('./routes/item_setup_complete_notify/_index');

// Events
require('./routes/events/_workflow');
require('./routes/events/_show');
require('./routes/events/_manage');
require('./routes/events/_common');

// New Vendor
importFiles(require.context('./routes/new_vendor/', true, /\.js$/i));
importFiles(require.context('./routes/vendor_name_change/', true, /\.js$/i));
importFiles(require.context('./routes/duplicate_vendor/', true, /\.js$/i));
importFiles(require.context('./routes/vendor_content/', true, /\.js$/i));

// ABC Item Pricing
require('./routes/abc_item/pricing/_index');
require('./routes/abc_item/pricing/_manage');
require('./routes/abc_item/pricing/_audit');
require('./routes/pricing_master_files/_index');

// ATP Document Module
importFiles(require.context('./routes/atp_documents/', true, /\.js$/i));

// 1WorldSync
require('./routes/one_ws/cis/_index');

// 3PM
importFiles(require.context('./routes/three_pm_import/', true, /\.js$/i));
importFiles(require.context('./routes/three_pm/price_change/', true, /\.js$/i));
importFiles(require.context('./routes/three_pm/price_change_resubmission/', true, /\.js$/i));

// Branded Specialty
importFiles(require.context('./routes/brand_promos/', true, /\.js$/i));
importFiles(require.context('./routes/brand_promo_campaigns/', true, /\.js$/i));
importFiles(require.context('./routes/brand_promo_performances/', true, /\.js$/i));

// Short Dated Injectables
importFiles(require.context('./routes/short_dated/', true, /\.js$/i));
importFiles(require.context('./routes/short_dated_injectables/', true, /\.js$/i));

//Internal NewItemLists
require('./routes/new_item_lists/_index');
require('./routes/category_assignment/_index');

// Replenishment Operations
importFiles(require.context('./routes/replenishment_operations/', true, /\.js$/i));

// Large Customer Opportunity Events
importFiles(require.context('./routes/new_customer_matching/events/', true, /\.js$/i));

//NBE Items
require('./routes/nbe_items/_index');

//LIR
importFiles(require.context('./routes/like_item_renaming/', true, /\.js$/i));

// SET
importFiles(require.context('./routes/set_case/', true, /\.js$/i));
